import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import SignatureAuditButtonConstants from './SignatureAuditButtonConstants';

const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);
const uuidV4 = require('uuid/v4');

export const getAuditHistory = (documentType, sessionId, userId, userToken) => (
  async (dispatch) => {
    try {
      dispatch({ type: SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_REQUEST });
      const payload = {
        session_id: sessionId,
        user_id: userId,
        user_token: userToken,
        v: uuidV4(),
      };
      const { data } = await formSwiftAPIClient.request(
        'POST',
        `/document/${documentType}/audit`, payload,
      );
      dispatch({
        type: SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_SUCCESS,
        auditList: data.audit_list,
      });
    } catch (e) {
      dispatch({
        type: SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_FAILURE,
        error: e.message,
      });
    }
  }
);

export const getAuditHistoryFromShareKey = shareKey => (
  async (dispatch) => {
    try {
      dispatch({ type: SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_REQUEST });
      const { data } = await formSwiftAPIClient.request(
        'GET',
        `/document/from-share-key/${shareKey}/audit?v=${uuidV4()}`,
      );
      dispatch({
        type: SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_FROM_SHARE_KEY_SUCCESS,
        auditList: data.audit_list,
      });
    } catch (e) {
      dispatch({
        type: SignatureAuditButtonConstants.SIGNATURE_AUDIT_HISTORY_GET_FAILURE,
        error: e.message,
      });
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/SignatureAuditButton/SignatureAuditButtonActions.jsx